"use strict";

var _collectionFilter = _interopRequireDefault(require("../components/collection-filter"));

var _quickView = _interopRequireDefault(require("../components/quick-view"));

require("url-search-params-polyfill");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Template: Search
 * ------------------------------------------------------------------------------
 * Highly coupled scripts to power the collection page functionality
 *
 * @namespace collection
 */

/**
 * Instantiate collection modules.
 */


(0, _collectionFilter["default"])().init();

if (theme.features.quickview) {
  (0, _quickView["default"])().init();
}